module.exports = __webpack_public_path__ + "static/media/28406.88c3d2bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/28406.svg
// module id = 42
// module chunks = 0